import React from 'react';
import styled from 'styled-components/macro';
import { SegmentedButton } from '../SubComponents/Buttons';

interface ItemCategoriesProps {
  className?: string;
  categories: string[];
  currentCategory: string;
  onChange: (category: string) => void;
}

let ItemCategories = (props: ItemCategoriesProps) => {
  return (
    <div className={props.className}>
      {props.categories.map((category) => (
        <SegmentedButton
          key={category}
          selected={props.currentCategory === category}
          onClick={() => props.onChange(category)}
          ml="2"
          mt="2"
        >
          {category}
        </SegmentedButton>
      ))}
    </div>
  );
};

ItemCategories = styled(ItemCategories)`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 32px;
`;

export default ItemCategories;
